import printHtml from '@/mixins/printHtml'

const productionAssemblyPrintAssembly = {
  mixins: [printHtml],
  methods: {
    async printAssembly(id, itemObject, print) {
      const isItem = !!itemObject;
      const results =  await this.$apiCall(`query productionAssemblyPrintAssembly($id:ID!, $isItem:Boolean!, $audit:Boolean!) {
                                              item(id:$id) @include(if:$isItem) {
                                                name,description,trackUnits
                                                bom {name,quantity,units,precision,lotTracking}
                                              }
                                              assembly(id:$id) @skip(if:$isItem) {
                                                date,duration,siteName,completed,itemName
                                                quantity,trackUnits,precision,lot,
                                                bom {name,units,quantity,precision,lot}
                                                comments
                                                audit @include(if:$audit) {userName,time,event}
                                              }
                                              assemblingPreferences {
                                                assemblyDuration
                                              }
                                            }`,
                                          {id, isItem, audit:this.$store.getters.company.allowAudit});
      if (results.error)
        return;

      const assembly = isItem ? results.data.item : results.data.assembly;
      const preferences = results.data.assemblingPreferences;

      if (isItem && itemObject.quantity !== undefined)
        item.bom.forEach(item => item.quantity = this.$roundNumber(item.quantity * itemObject.quantity, item.precision));

      const lines = [`
        <style>
          @page {size:portrait}
          table {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px;table-layout:fixed}
          td {padding:5px;height:30px;position:relative}
          .title {font-weight:bold;text-align:center;font-size:150%;padding-bottom:40px}
          .subtitle {font-weight:medium;text-align:center;height:10px}
          .box {${isItem ? 'border-bottom:thin solid #aaa':''}}
          .label {display:inline-block;top:-8px;position:absolute;xbackground-color:#fff;xpadding-left:5px;xpadding-right:5px;font-size:90%}
          .suffix {display:inline-block${isItem ? ';float:right' : ''}}
          .placeholder {${isItem ? 'color:#888' : ''}}
          .half-line {height:20px}
          .hint {text-align:center; font-size:9px}
          .inner-table {border:thin solid #ccc; padding:10px}
          .page-break {page-break-before: always;}
          .incomplete {font-size:50px;opacity:0.2;text-align:center}
        </style>
        <table>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <col style="width:5%"/><col style="width:5%"/><col style="width:5%"/><col style="width:5%"/>
          <thead>
            ${isItem || assembly.completed ? '' : `<tr><td colspan="20" class="incomplete">INCOMPLETE</td></tr>`}
            <tr><td colspan="20" class="subtitle">${this.company.name}</td></tr>
            <tr><td colspan="20" class="title">Assembly ${isItem ? assembly.name : assembly.itemName}</td></tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="5" class="box"><div class="label">Date</div>
                <span class="placeholder">
                  ${isItem?`${itemObject.date ? this.$formatDateTime(itemObject.date) : ''}`:this.$formatDateTime(assembly.date)}
                </span>
              </td>
              <td/>
              ${preferences.assemblyDuration ? `<td colspan="4" class="box"><div class="label">Duration</div>${isItem?'':this.$options.filters.duration(assembly.duration)}</td>` : '<td colspan="4"/>'}
              <td colspan="4"/>
              ${this.$store.getters.sites(true, true).length ? `<td colspan="6" class="box"><div class="label">Site</div>
                ${isItem?itemObject.siteName??'':assembly.siteName}
              </td>` : '<td colspan="6"/>'}
            </tr>
            <tr><td colspan="20"/></tr>
            ${assembly.description ? `<tr><td colspan="10">${assembly.description}</td></tr><tr><td colspan="20" class="half-line"/></tr>` : '<tr><td colspan="20"/></tr>'}
            <tr>
              <td colspan="4" class="box">
                <div class="label">Quantity</div>
                ${isItem ? (itemObject.quantity !== undefined ? `<span class="placeholder">${this.$number(itemObject.quantity,assembly.precision)}</span>` : '') : this.$number(assembly.quantity,assembly.precision)}
                <div class="suffix">${assembly.trackUnits}</div>
                </td>
              <td/>
              <td colspan="3" class="box">
                <div class="label">Lot code</div>
                ${isItem ? '' : assembly.lot}
              </td>
            </tr>
            <tr><td colspan="20" class="half-line"/></tr>

            <tr>
              <td colspan="20" class="inner-table">
                <table>

            <tr>
              <td colspan="8" class="half-line"><strong>Item</strong></td>
              <td/>
              <td colspan="6" class="half-line"><strong>Quantity</strong></td>
              <td/>
              <td colspan="4" class="half-line"><strong>Lot</strong></td>
            </tr>
        `];

      for (const item of assembly.bom) {
        lines.push(`
          <tr>
            <td colspan="8" class="box">${item.name}</td>
            <td/>
            <td colspan="6" class="box">
              ${isItem ? (itemObject.quantity !== undefined ? `<span class="placeholder">${this.$number(item.quantity, item.precision)}</span>` : '') : this.$number(item.quantity, item.precision)}
              <div class="suffix">${item.units}</div>
            </td>
            <td/>
            <td colspan="4" class="box">${isItem?`${item.lotTracking?'':'n/a'}`:item.lot??''}</td>
          </tr>`);
        if (isItem)
          lines.push(`
          <tr>
            <td colspan="9" class="half-line"/>
            <td colspan="6" class="half-line hint">
              ${this.$number(item.quantity, item.precision)} per ${assembly.trackUnits}
            </td>
          </tr>
        `);
      }
      if (isItem)
        lines.push(`
          <tr>
            <td colspan="8" class="box"></td>
            <td/>
            <td colspan="6" class="box"></td>
            <td/>
            <td colspan="4" class="box"></td>
          </tr>`);
      lines.push(`
          </table>
      </td>
    </tr>

        <tr><td/></tr>
        <tr>
          <td colspan="20" class="box" style="height:60px"><div class="label">Comments</div>
          ${isItem?'':assembly.comments}
          </td>
        </tr>`);

      if (isItem)
        lines.push(`
        <tr><td/></tr>
        <tr><td/></tr>
        <tr>
          <td colspan="8" class="box"><div class="label">Performed by</div></td>
          <td/>
          <td colspan="8" class="box"><div class="label">Signature</div></td>
        </tr>`);

      else if (this.$store.getters.company.allowAudit) {
        lines.push(`<tr>
                      <td colspan="4"><strong>Date</strong></td>
                      <td/>
                      <td colspan="5"><strong>User</strong></td>
                      <td/>
                      <td colspan="9"><strong>Action</strong></td>
                    </tr>`);
        for (const audit of assembly.audit)
          lines.push(`<tr>
                        <td colspan="4">${this.$formatDateTime(audit.time)}</td>
                        <td/>
                        <td colspan="5">${audit.userName}</td>
                        <td/>
                        <td colspan="9">${audit.event}</td>
                      </tr>`);
      }

      lines.push(`
        </tbody>
        </table>
      `);

      if (print)
        this.printHtml('Assembly',lines.join(''));
      else
        return lines;
    }
  }
}

export default productionAssemblyPrintAssembly;